import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LoanService } from "../../shared/loan.service";
import { environment } from '../../../../environments/environment';
import { Loan } from "../loan";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})

export class PrintloanrequestformService {

  public selectedLoan: Loan;

  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe) {
  }

  GenerateReport(rptSearchData: any) {
    this.FetchLoanRequestForm(rptSearchData)
      .toPromise()
      .then(data => {
        this.ReportLoanRequestForm(data);
      })
      .catch(err => { console.log(err) });

    // this.loanService.FetchReportsLoanList(rptSearchData)
    // .toPromise()
    // .then(data => {
    //   // this.ReportLoanRequestForm(data);
    // })
    // .catch(err => { console.log(err) });

  }

  getBaseUrl() {
    return environment.baseUrl;
  }

  FetchLoanRequestForm(rptSearchData: any) {

    this.selectedLoan = new Loan();
    this.selectedLoan.ReportName = "LoanReport";
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.Id = + rptSearchData.Id;
    this.selectedLoan.CustomerId = + rptSearchData.CustomerId;
    this.selectedLoan.FromDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.selectedLoan.ToDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];


    this.selectedLoan.SchemeId = 0;
    this.selectedLoan.LoanTypeId = 0;
    this.selectedLoan.loanCategoryId = 0;
    this.selectedLoan.LoanApprovedStatusId = 0;
    this.selectedLoan.BranchId = 0;
    this.selectedLoan.CentreId = 0;
    this.selectedLoan.LoanApprovedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.selectedLoan.ApplicationDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    console.log(body);
    console.log(this.getBaseUrl());

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }

  ReportLoanRequestForm(loanDetail) {

    console.log('loanDetail');
    console.log(loanDetail);

    var doc = new jsPDF('p', 'pt', 'A4')

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    doc.addImage(img, 'png', 120, 60, 50, 50);

    // Top HEADER
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(14);
    doc.setFont('arial', 'bold');
    doc.text("SRI", 290, 40);  // 40 is the height
    doc.setFont('arial', 'normal');
    doc.text("Society For Rural Improvements", 210, 60);  // 40 is the height

    doc.setFontSize(10);
    doc.text("(A REGISTERED TRUST)", 255, 80);
    doc.setFontSize(12);
    doc.text("Reg. No. 22/IV/1996 ", 265, 100);

    doc.text("SRI , Sri gramam  P B No. 2, P.O. Kollengode, ", 210, 120);
    doc.text("Palakkad Dist. , Kerala, INDIA - 678506", 225, 140);

    // doc.setLineWidth(1);
    // doc.line(5, 145, 790, 145)
    doc.setFontSize(14);
    doc.setFont('arial', 'bold');
    doc.text("Loan Request Form", 255, 160);
    doc.line(5, 165, 790, 165);

    doc.setFontSize(12);
    doc.setFont('arial', 'normal');
    doc.text("Branch : " + loanDetail[0].CustomerBranchName, 35, 180);
    doc.text("No of Loan : " + loanDetail[0].TotalLoanCount, 400, 180);

    doc.text("Centre : " + loanDetail[0].CentreName, 35, 200);
    doc.text("Loan No : " + loanDetail[0].LoanNumber, 400, 200);

    doc.text("Passbook No: " + loanDetail[0].SavingsNumber, 35, 220);

    if(loanDetail[0].PhotoFilePath == null){
      doc.addImage("../../../assets/staffimages/no_image_2.jpg", 400, 220, 100, 100); // photo 
    }
    else{
      doc.addImage(loanDetail[0].PhotoFilePath, 400, 220, 100, 100); // photo 
    }

    doc.text("a. Applicant Name :" + loanDetail[0].CustomerName, 45, 240);
    doc.text("b. Guadian Name :" + loanDetail[0].Guardian , 45, 260);
    var strArr = doc.splitTextToSize(loanDetail[0].CustomerAddress, 50);
    doc.text("c. Permanent Address :" + strArr , 45, 280,  { maxWidth: 350 });
    doc.text("d. Martial Status : " + loanDetail[0].MartialStatus , 45, 350);

    doc.text("e. Land Details :" + "", 45, 370);
    doc.text(" a) Farming " + "", 200, 370);
    doc.text(" b) House " + "", 400, 370);

    doc.text("f. Asset Details " + "", 45, 390);
    doc.text(" a) Cattles " + "", 200, 390);
    doc.text(" b) Others " + "", 400, 390);

    doc.text("g. House Details: " + "", 45, 410);
    doc.text(" h. Annual Income: " + loanDetail[0].AnnualIncome, 400, 410);

    doc.text("i. Other loan, If any: " + "", 45, 430);

    doc.text(" Last Loan Details: ", 25, 460);

    // doc.setFontSize(10);
    // doc.setFont('arial', 'normal');

    // Header Name rows of First table
    function headRows() {
      return [{
        Occupation: 'Occupation', Amount: 'Amount', WeeklyDemand: 'Weekly Demand',
        PaidAmount: 'Paid Amount', Otherdetails: 'Other details'
      }];
    }

    // doc.line(5, 130, 790, 130)   // x-axis, -x-axix,  y-axis  , -y-axix        
    let head = headRows();
    // let body = null;
    const body = [
      [loanDetail[0].OccupationName, , "", "",""],
    ];

    autoTable(doc, {
      startY: 470,
      margin: {
        left: 25,
      },
      head: head, //head is the header that you have created
      body: body,
      theme: 'grid', //'striped', //
      headStyles: { fillColor: [65, 105, 225] },
    });

    doc.text(" Current Loan Requested details: ", 25, 550);

    // Header Name rows of Second table
    function headRows2() {
      return [{
        Occupation: 'Occupation', Amount: 'Requested Amount', CentreManager: 'Centre Manager', BranchManager: 'Branch Manager',
        Otherdetails: 'Other details'
      }];
    }

    // doc.line(5, 130, 790, 130)   // x-axis, -x-axix,  y-axis  , -y-axix
    let head2 = headRows2();
    let body2  = [
      [ loanDetail[0].OccupationName, loanDetail[0].LoanAmount, loanDetail[0].LoanAmount, loanDetail[0].LoanAmount,""],
    ];

    autoTable(doc, {
      startY: 560,
      margin: {
        left: 25,
      },
      head: head2, //head is the header that you have created
      body: body2,
      theme: 'grid', //'striped', //
      headStyles: { fillColor: [65, 105, 225] },
    });

    doc.text(" Declaration: ", 25, 650);
    doc.text("I hereby promise to abide by the rules and regulations concerning the SRI, the Society For Rural Improvements " +
      " ", 25, 670);
    doc.text(" Date: ", 45, 700);
    doc.text(" Appplicant Sign: ", 410, 700);

    doc.text("We are agreed to add the above applicant into the Sangam and the Centre ", 25, 740);

    doc.text(" Sign: ", 45, 760);
    doc.text(" Sangam Leader", 45, 780);

    doc.text(" Sign: ", 410, 760);
    doc.text(" Centre Leader", 410, 780);

    // doc.setLineWidth(1);
    // doc.line(5, 70, 790, 70)
    // Top HEADER END 

    // return doc;
    doc.output('dataurlnewwindow');

  }
  
}
